import React, { useState, useEffect } from 'react';
import Fuse from 'fuse.js';
import { Box, TextField, AppBar, Toolbar, Grid, Card, CardMedia, CardContent, Typography, ToggleButton, ToggleButtonGroup, CardActionArea } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getCurrentIdentity } from '../userIdentity'; // <--- 1. ДОБАВЛЕН ИМПОРТ

const Bots = () => {
  const [search, setSearch] = useState('');
  const [bots, setBots] = useState([]);
  const [filteredBots, setFilteredBots] = useState([]);
  const [sort, setSort] = useState('Новые');
  const [userId, setUserId] = useState(null); // <--- 2. ДОБАВЛЕН СТЕЙТ ДЛЯ userId
  const navigate = useNavigate();

  // <--- 3. ЗАГРУЖАЕМ IDENTITY ПРИ МОНТИРОВАНИИ
  useEffect(() => {
    const loadIdentity = async () => {
      try {
        const identity = await getCurrentIdentity();
        if (identity?.userId) {
          setUserId(identity.userId);
        }
      } catch (err) {
        console.error('Ошибка загрузки identity:', err);
      }
    };
    loadIdentity();
  }, []);

  // <--- 4. ОБНОВЛЯЕМ СПИСОК ПРИ ИЗМЕНЕНИИ СОРТИРОВКИ ИЛИ userId
  useEffect(() => {
    fetchBots();
  }, [sort, userId]);

  const fetchBots = async () => {
    try {
      const sortQuery = sort === 'Популярные' ? 'popular' : 'new';
      // <--- 5. ПЕРЕДАЕМ userId В QUERY ПАРАМЕТРАХ
      const userParam = userId ? `&userId=${userId}` : '';
      const response = await fetch(`/api/bots?sort=${sortQuery}${userParam}`);

      if (!response.ok) return;

      const data = await response.json();

      setBots(data);
      setFilteredBots(data);
    } catch (error) {
      console.error('Error fetching bots:', error);
    }
  };

  const handleSortChange = (event, newSort) => {
    if (newSort) {
      setSort(newSort);
    }
  };

  // Передаем state, чтобы знать, что пришли из списка ботов
  const handleBotClick = (botId) => {
    navigate(`/bot/${botId}`, { state: { from: 'bots' } });
  };

  return (
    <Box>
      <AppBar position="sticky" color="default" elevation={0} sx={{ backgroundColor: '#1e1e1e', borderBottom: '1px solid #333' }}>
        <Toolbar sx={{ justifyContent: 'center' }}>
          <TextField
            variant="outlined"
            placeholder="Поиск ботов..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            size="small"
            fullWidth // Растянули на всю ширину
            sx={{ backgroundColor: '#2a2a2a', borderRadius: '12px' }}
          />
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'center', mb: 2 }}>
        <ToggleButtonGroup value={sort} exclusive onChange={handleSortChange} color="primary">
          <ToggleButton value="Новые" sx={{ borderRadius: '12px', fontStyle: 'italic', color: 'white' }}>Новые</ToggleButton>
          <ToggleButton value="Популярные" sx={{ borderRadius: '12px', fontStyle: 'italic', color: 'white' }}>Популярные</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Grid container spacing={2} sx={{ px: 2, pb: '90px' }}>
        {filteredBots.length === 0 ? (
          <Typography variant="h6" color="text.secondary" sx={{ fontStyle: 'italic', textAlign: 'center', width: '100%' }}>
            Пока-что нету ботов
          </Typography>
        ) : (
          filteredBots.map((bot) => (
            <Grid item xs={6} key={bot.id}>
              <Card 
                sx={{ 
                    borderRadius: '12px', 
                    backgroundColor: '#2a2a2a', 
                    border: '1px solid #333', 
                    transition: 'all 0.3s ease',
                    height: '100%'
                }}
              >
                <CardActionArea onClick={() => handleBotClick(bot.id)} sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                    <CardMedia component="img" height="140" image={bot.avatar || 'placeholder'} alt={bot.name} sx={{ borderRadius: '12px 12px 0 0' }} />
                    <CardContent sx={{ p: 1, width: '100%' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', fontStyle: 'italic', color: 'white' }}>
                        {bot.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', color: '#aaa' }}>
                        {bot.genres} • {bot.gender}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ opacity: 0.7, fontStyle: 'italic', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', color: '#888' }}>
                        {bot.description}
                    </Typography>
                    </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  );
};

export default Bots;